// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4644f7fe] .ant-table-fixed-header .ant-table-scroll .ant-table-header {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  overflow: hidden;\n}\n.detail-footer[data-v-4644f7fe] {\n  margin-top: 16px;\n  text-align: right;\n  border-top: 1px solid #e8e8e8;\n  padding-top: 12px;\n}\n.detail-footer__label[data-v-4644f7fe] {\n  margin-right: 16px;\n  font-weight: 600;\n}\n.detail-footer__amount[data-v-4644f7fe] {\n  font-size: 16px;\n  font-weight: 600;\n}\n", ""]);
// Exports
module.exports = exports;
